import { render, staticRenderFns } from "./FaqPageManager.vue?vue&type=template&id=088d81d0&"
import script from "./FaqPageManager.vue?vue&type=script&lang=js&"
export * from "./FaqPageManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports